import { isSuccess, Result } from '@carvana/merch-result';
import { axios } from '~/clients';
import { VERIFY_EMAIL } from '~/constants/endpoints';

export enum EmailStatus {
  AcceptAll = 'AcceptAll',
  Invalid = 'Invalid',
  Unknown = 'Unknown',
  Valid = 'Valid'
}

export enum EmailError {
  Disposable = 'Disposable',
  EmailAccountInvalid = 'EmailAccountInvalid',
  EmailAddressInvalid = 'EmailAddressInvalid',
  EmailDomainInvalid = 'EmailDomainInvalid',
  MailboxFull = 'MailboxFull',
  RoleAddress = 'RoleAddress'
}

export type Verification = {
  detail?: string;
  error?: EmailError;
  status: EmailStatus;
};

export default function verifyEmail(
  emailAddress: string
): Promise<Verification> {
  return axios
    .post<Result<Verification>>(VERIFY_EMAIL, emailAddress, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then(({ data }) => {
      if (isSuccess(data)) {
        return data.content;
      }

      throw new Error(data.errorMessage);
    });
}
